import { createSlice } from "@reduxjs/toolkit"

const patientInitialState = {
  uploadPrescriptionModalIsOpen: false,
  prescriptionFiles: [],
  patientsList: [],
  selectPatientModalIsOpen: false,
  addNewPatientModalIsOpen: false,
  selectedTest: {},
  loginFlowPrimarySelection: false,
}

const patientSlice = createSlice({
    name: 'patientDataReducer',
    initialState: patientInitialState,
    reducers: {
        uploadPrescriptionData: (state, action) => {
            state.uploadPrescriptionModalIsOpen = action.payload.uploadPrescriptionModalIsOpen
            state.prescriptionFiles = action.payload.prescriptionFiles
        },
        askUserToSelectPatient: (state, action) => {
            state.selectPatientModalIsOpen =
              action.payload.selectPatientModalIsOpen
            state.selectedTest = action.payload.selectedTest
            state.loginFlowPrimarySelection =
              action.payload.loginFlowPrimarySelection
        },
        askUserToAddPatient: (state, action) => {
            state.addNewPatientModalIsOpen = action.payload.addNewPatientModalIsOpen
        }
    }
})
export const { uploadPrescriptionData, askUserToSelectPatient, askUserToAddPatient } = patientSlice.actions
export default patientSlice.reducer